import {Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { SubscriptionList } from '../../models/asp.types';
import { unsubscribeSubscriptions } from '../../services/util.service';

@Component({
  selector: 'app-add-item',
  templateUrl: './add-item.component.html',
  styleUrls: ['./add-item.component.scss']
})
export class AddItemComponent implements OnInit, OnDestroy {

  title: string ;
  actionText: string = 'scheduleRotation.add';
  isEditMode = false;
  @ViewChild('form') form: ElementRef;
  clickedOutside=false;
  private subs: SubscriptionList = {};
  itemForm: UntypedFormGroup;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<AddItemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.title = data.title;
  }

  ngOnInit() {
    this.itemForm = this.formBuilder.group({
      name: ['', Validators.required]
    });

    if(this.data.type === 'shift'){
      this.itemForm.addControl('fromTime', this.formBuilder.control('', [Validators.required]));
      this.itemForm.addControl('toTime', this.formBuilder.control('', [Validators.required]));
    }

    this.setUpEditMode();
  }
  
  @HostListener("document:click", ['$event.target'])
  showMessage(event)
  {    
    if (!this.form.nativeElement.contains(event) )
    {
      if( this.data.clicked) {
          this.data.clicked=false;
        }
      else{
          this.clickedOutside=true;
        }
      }
  }

  returnOutsideClicks()
  {
    return this.clickedOutside;
  }
  
  close() {
    this.dialogRef.close({action: 'cancel'});
  }

  onActionClicked() {
    this.dialogRef.close({action: 'confirm', data: this.itemForm.value});
  }

  private setUpEditMode() {
    this.isEditMode = !!this.data.isEditMode;
    if (this.isEditMode) {
      this.itemForm.patchValue(this.data.formVal);
      this.actionText = 'scheduleRotation.update';
    }
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }
}

